"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMappingHeaderUri = exports.getMappingHeaderIdentifier = exports.getAttributeHeaderItemName = exports.getMappingHeaderFormattedName = exports.getMappingHeaderName = exports.getMappingHeaderLocalIdentifier = exports.hasMappingHeaderFormattedName = exports.hasMappingHeaderLocalIdentifier = void 0;
// (C) 2007-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
//
//
//
/**
 * @internal
 */
function hasMappingHeaderLocalIdentifier(header) {
    return sdk_model_1.isAttributeDescriptor(header) || sdk_model_1.isMeasureDescriptor(header);
}
exports.hasMappingHeaderLocalIdentifier = hasMappingHeaderLocalIdentifier;
/**
 * @internal
 */
function hasMappingHeaderFormattedName(header) {
    return sdk_model_1.isResultAttributeHeader(header) && !!header.attributeHeaderItem.formattedName;
}
exports.hasMappingHeaderFormattedName = hasMappingHeaderFormattedName;
/**
 * @internal
 */
function getMappingHeaderLocalIdentifier(header) {
    if (sdk_model_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.localIdentifier;
    }
    else if (sdk_model_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.localIdentifier;
    }
    throw new Error("Mapping header of type \"" + Object.keys(header) + "\" has no localIdentifier");
}
exports.getMappingHeaderLocalIdentifier = getMappingHeaderLocalIdentifier;
/**
 * @internal
 */
function getMappingHeaderName(header) {
    if (sdk_model_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.formOf.name;
    }
    else if (sdk_model_1.isResultAttributeHeader(header)) {
        return header.attributeHeaderItem.name;
    }
    else if (sdk_model_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.name;
    }
}
exports.getMappingHeaderName = getMappingHeaderName;
/**
 * Get formatted name of provided mapping header.
 *
 * Formatted name has higher priority than name when displaying in visualisations.
 *
 * @internal
 */
function getMappingHeaderFormattedName(header) {
    if (sdk_model_1.isResultAttributeHeader(header)) {
        return getAttributeHeaderItemName(header.attributeHeaderItem);
    }
    else {
        return getMappingHeaderName(header);
    }
}
exports.getMappingHeaderFormattedName = getMappingHeaderFormattedName;
/**
 * Get formatted name of provided attribute header item.
 *
 * Formatted name has higher priority than name when displaying in visualisations.
 *
 * @internal
 */
function getAttributeHeaderItemName(attributeHeaderItem) {
    var _a;
    return (_a = attributeHeaderItem === null || attributeHeaderItem === void 0 ? void 0 : attributeHeaderItem.formattedName) !== null && _a !== void 0 ? _a : attributeHeaderItem === null || attributeHeaderItem === void 0 ? void 0 : attributeHeaderItem.name;
}
exports.getAttributeHeaderItemName = getAttributeHeaderItemName;
/**
 * @internal
 */
function getMappingHeaderIdentifier(header) {
    if (sdk_model_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.identifier;
    }
    else if (sdk_model_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.identifier;
    }
    throw new Error("Mapping header of type \"" + Object.keys(header) + "\" has no identifier");
}
exports.getMappingHeaderIdentifier = getMappingHeaderIdentifier;
/**
 * @internal
 */
function getMappingHeaderUri(header) {
    if (sdk_model_1.isAttributeDescriptor(header)) {
        return header.attributeHeader.uri;
    }
    else if (sdk_model_1.isResultAttributeHeader(header)) {
        return header.attributeHeaderItem.uri;
    }
    else if (sdk_model_1.isMeasureDescriptor(header)) {
        return header.measureHeaderItem.uri;
    }
}
exports.getMappingHeaderUri = getMappingHeaderUri;
//# sourceMappingURL=MappingHeader.js.map